

<template>
    <div> 
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/images/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>  
    </div>
</template>


<script>
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
// import moment from 'moment'

import liff from '@line/liff';

export default {
    name: 'Home',
    components:{},
    data () {
        return {
            UserData:{},
            profile: null,
            AccessToken:'',
            ProviderUserId:'',
            showLoading:'',
        }
    },
    beforeCreate(){
        liff.init({ liffId: process.env.LIFFMEMBER })
        .then(async () => {
            if (liff.isLoggedIn()) {
                this.profile = liff.getProfile();
                this.AccessToken = liff.getAccessToken();
                this.DecodedIDToken = liff.getDecodedIDToken();
                console.log('profile',this.profile)
                console.log('AccessToken',this.AccessToken)
                console.log('DecodedIDToken',this.DecodedIDToken)
                sessionStorage.setItem('DecodedIDToken', JSON.stringify(this.DecodedIDToken));
                sessionStorage.setItem('AccessToken',this.AccessToken);
                this.profile.then((value) => {
                    sessionStorage.setItem('profile', JSON.stringify(value));
                    this.ProviderUserId = value.userId;
                    this.$nextTick(() => {
                        console.log('ProviderUserId',this.ProviderUserId);
                        this.CheckThirdPartyAuthUserId();
                    });
                });
                
            } else {
                liff.login();
            }
        })
        .catch((err) => {
            console.log(err);
        })
    },
    mounted(){
    },
    methods:{
        //驗證是否綁定過Line ID
        CheckThirdPartyAuthUserId(){
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/Login/CheckThirdPartyAuthUserId`;
            const inputdata = 
            {
                "ProviderId":1, // Line用,
                "AccessToken":this.AccessToken,
                "ProviderUserId": this.ProviderUserId,
            };

            axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.isSuccess){
                        this.UserData = response.data.userData;
                        sessionStorage.setItem('UserData',JSON.stringify(this.UserData));
                        //跳轉會員畫面
                        this.$router.push({
                            name: 'MemberCard',
                        });
                    }else{
                        //跳轉登入畫面
                        this.$router.push({
                            name: 'Login',
                        });
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        GoHiQuiz(URL){
            liff.openWindow({
                url: URL,
                external: true,
            });
        },
    },
    created(){
        this.$root.$refs.home = this;
        // this.AccessToken = sessionStorage.getItem('AccessToken');
        // this.profile = JSON.parse(sessionStorage.getItem('profile'));
        // this.ProviderUserId = this.profile.userId;
        // this.CheckThirdPartyAuthUserId();

    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Home.vue